module.exports = __webpack_public_path__ + "media/images/people/4-8fc3886deef4e1844b9f5d3ea5b15b5c.jpg";